import React, { useContext } from "react";
import { ButtonGroup, Button, ResourceItem, InlineStack, BlockStack, Text, Badge, Link } from "@shopify/polaris";
import PropTypes from "prop-types";

// import from lib
import { baseHelper } from "lib/helpers";
import constant from "lib/constant/constant";

import { PrivateContext } from "lib/context";

// import cms
import cmsVendorList from "app/advanceVendor/modules/operator/feature/list/cms/vendorList";

const VendorListView = (props) => {
  const { cms } = useContext(PrivateContext);
  const { item, keyIndex, onDeleteVendor, onLoginVendor } = props;
  const { _id, lastName, firstName, email, brandName, createdAt, roles } = item;
  const { address = "", verified } = email || {};
  const { name: role } = roles;
  const vendorListCMS = cmsVendorList(cms);
  const { button, label } = vendorListCMS;

  return (
    <>
      <ResourceItem id={_id} sortOrder={keyIndex} accessibilityLabel={`${label.viewDetailsFor} ${brandName}`}>
        <InlineStack wrap={false} align="space-between" blockAlign="start">
          <BlockStack gap="100">
            <Text variant="headingMd" as="h4">
              <Link url={`/providers/profile/${_id}`}>
                {baseHelper.ucFirst(brandName) || cms("error.common.emptyBrandName")}
              </Link>
            </Text>
            <Text as="h5">{`${label.name} ${firstName || cms("error.common.emptyName")} ${lastName || ""}`}</Text>
            <Text as="h5">{`${label.email} ${address}`}</Text>
            <Text as="span" tone="subdued">{`${label.onBoardedOn} ${baseHelper.formatDate(createdAt)}`}</Text>
          </BlockStack>
          <InlineStack gap="200">
            <Badge tone={verified ? constant.SUCCESS : constant.NEW}>
              {verified ? constant.APPROVED : constant.PENDING}
            </Badge>
            <ButtonGroup>
              <Button size="slim" variant="primary" tone="critical" onClick={() => onDeleteVendor(_id)}>
                {button.deleteVendor}
              </Button>
              <Button size="slim" onClick={() => onLoginVendor(_id, brandName, role)}>
                {button.loginVendor}
              </Button>
              <Button size="slim" url={`/providers/edit/${_id}`}>
                Edit
              </Button>
            </ButtonGroup>
          </InlineStack>
        </InlineStack>
      </ResourceItem>
    </>
  );
};

VendorListView.defaultProps = {
  item: {},
  keyIndex: "",
  onDeleteVendor: () => {},
  onLoginVendor: () => {},
};

VendorListView.propTypes = {
  item: PropTypes.shape(PropTypes.object),
  keyIndex: PropTypes.number,
  onDeleteVendor: PropTypes.func,
  onLoginVendor: PropTypes.func,
};

export default VendorListView;
